[
    {
        "id": "06bf8099-f62e-4193-9827-b7e44b36afa2",
        "loan_application_id": "bf40efb3-a688-4972-8335-d3e1c7c00c4b",
        "clabe": "012000000000000100",
        "account": 0,
        "account_holder": "",
        "bank_id": "e640c900-9cd5-4cc8-9fc7-f0236379a41b",
        "client_details_id": "6b75bbf4-afa9-42d1-a70d-84e903d8a3b9",
        "person_id": null,
        "bank_statment_first_documents_id": null,
        "bank_statment_second_documents_id": null,
        "bank_statment_third_documents_id": null,
        "principal": false,
        "bank_card": "2020202020202003",
        "owner": "FERMIN SUAREZ MENDOZA",
        "account_client_number": null,
        "client_address": null,
        "client_rfc": null,
        "bank_branch": null,
        "active": true,
        "created_at": "2025-08-29T21:35:46.456808",
        "updated_at": "2025-10-08T16:30:49.671538",
        "documents": [
            {
                "bank_statement_document_id": "ddc0f9f0-7dee-4592-ad0d-e8f358cd679a",
                "document_id": "0e5bfe6c-f880-4afb-b5fb-db83b195a909",
                "document_order": 2
            },
            {
                "bank_statement_document_id": "11fa3975-71e6-45f3-bde5-2ae8fc4eca1a",
                "document_id": "ba60846f-2afe-4450-82d2-3ee546354279",
                "document_order": 1
            },
            {
                "bank_statement_document_id": "30eca6ae-2322-46f1-b6e1-538bfdf483c2",
                "document_id": "d4a0fa0b-d76d-4e28-9cd6-210b693b14ab",
                "document_order": 3
            }
        ],
        "bank": {
            "id": "e640c900-9cd5-4cc8-9fc7-f0236379a41b",
            "name": "BBVA BANCOMER",
            "description": "BBVA Bancomer, S.A., Institución de Banca Múltiple, Grupo Financiero BBVA Bancomer",
            "code": "012"
        },
        "domiciliation_order": null
    },
    {
        "id": "24d26755-0431-4b15-a297-f11a18c84585",
        "loan_application_id": "bf40efb3-a688-4972-8335-d3e1c7c00c4b",
        "clabe": "012000000000000099",
        "account": 0,
        "account_holder": "",
        "bank_id": "e640c900-9cd5-4cc8-9fc7-f0236379a41b",
        "client_details_id": "6b75bbf4-afa9-42d1-a70d-84e903d8a3b9",
        "person_id": null,
        "bank_statment_first_documents_id": null,
        "bank_statment_second_documents_id": null,
        "bank_statment_third_documents_id": null,
        "principal": false,
        "bank_card": "4343434343434342",
        "owner": "FERMIN SUAREZ MENDOZA",
        "account_client_number": null,
        "client_address": null,
        "client_rfc": null,
        "bank_branch": null,
        "active": true,
        "created_at": "2025-08-29T21:05:23.471057",
        "updated_at": "2025-10-08T16:17:43.262731",
        "documents": [
            {
                "bank_statement_document_id": "92f02105-f4c2-4bab-b2d1-4b345c0e2a23",
                "document_id": "7401b6e5-e9df-477c-81d7-5ab55d0ccaeb",
                "document_order": 3
            },
            {
                "bank_statement_document_id": "75b70cf5-d258-4221-a643-da4fc840d60c",
                "document_id": "66882a91-e5b4-4ba2-8d45-b125434ec4a0",
                "document_order": 1
            },
            {
                "bank_statement_document_id": "fb18ae98-6e04-4d9a-8509-5e8486236f94",
                "document_id": "c97637dd-ae93-4cd1-bb42-713a3a930e8f",
                "document_order": 2
            }
        ],
        "bank": {
            "id": "e640c900-9cd5-4cc8-9fc7-f0236379a41b",
            "name": "BBVA BANCOMER",
            "description": "BBVA Bancomer, S.A., Institución de Banca Múltiple, Grupo Financiero BBVA Bancomer",
            "code": "012"
        },
        "domiciliation_order": null
    }
]
